import * as XLSX from 'xlsx';


export default class DocumentProcessingService {
  
  parseCSV(text: string) {
    const lines = text.split('\n');

    const headerRow = lines[0].split(',');
    const headerCells = headerRow.map(cell => cell.trim());
    const bodyRows = lines.slice(1);
    
    const rawTableData: Record<string, any>[] = [];
    
    for (let row of bodyRows) {
      const cells = row.split(',');
      
      const newRow: Record<string, any> = {};

      headerCells.forEach((header, headerIndex) => {
        newRow[header] = cells[headerIndex]?.trim() || '';
      });

      rawTableData.push(newRow);
    }

    return { rawTables: [rawTableData], surfacesColumns: [headerCells] };
  }

  parseExcel(buff: ArrayBuffer) {
    const bitMap = new Uint8Array(buff);
    const workbook = XLSX.read(bitMap, { type: 'array' });
    const sheets = Object.entries(workbook.Sheets).map(([_, sheet]) => sheet);
    const rawTableData: Record<string, any>[][] = sheets.map((sheet) => XLSX.utils.sheet_to_json(sheet));
    const surfacesColumns = rawTableData.map((table) => {
      const columnsHeap = table.map((row) => Object.keys(row)).flat();
      return Array.from(new Set(columnsHeap));
    });
    return { rawTables: rawTableData, surfacesColumns};
  }
}